import { useEffect } from 'react';

import { useAccountGet } from '@sbv-clients/data-access-api';
import { useAuth } from '@sbv-clients/shared-feature-auth';

import { identifyMixpanelUser } from './mixpanel';

export const useMixpanelIdentity = (): void => {
  const { data: account } = useAccountGet();
  const { facilityEmployeeId, facilityId } = useAuth();

  useEffect(() => {
    if (!account?.id) {
      return;
    }

    const activeProfile =
      account.profiles?.find(
        (profile) => profile.id === account.tokenProfileId
      ) ?? (account.profiles?.length === 1 ? account.profiles[0] : undefined);

    identifyMixpanelUser(account, activeProfile, {
      facilityEmployeeId,
      facilityId,
    });
  }, [account, facilityEmployeeId, facilityId]);
};
